import { render, staticRenderFns } from "./ShopStoreProduct.vue?vue&type=template&id=cca08806&scoped=true"
import script from "./ShopStoreProduct.vue?vue&type=script&lang=js"
export * from "./ShopStoreProduct.vue?vue&type=script&lang=js"
import style0 from "./ShopStoreProduct.vue?vue&type=style&index=0&id=cca08806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca08806",
  null
  
)

export default component.exports